// Connectivity quality band classifier -- the single source of truth reused by
// both field_network_health.js (drives the three-level connectivity model,
// ADR-0110) and pwa/network_diagnostics_controller.js (drives the manual
// ping-test readout on the diagnostics page). Extracted into its own tiny leaf
// module so neither ever drifts out of step with the other -- ADR-0110 is
// explicit that a second classifier must never be invented alongside this one.
//
// Not field- or chat-prefixed: pwa/network_diagnostics_controller.js is a
// SHARED base class (extended by both field_network_diagnostics_controller.js
// and chat_network_diagnostics_controller.js), so this constants module has to
// sit at the same "generic, app-agnostic" layer rather than under a field_*
// name, or the shared base would end up importing app-specific code.
//
// avgMs == null means "no response" (a confirmed failure), not merely absent
// -- it is treated the same as total packet loss.

export const QUALITY_GOOD      = "good"
export const QUALITY_FAIR      = "fair"
export const QUALITY_POOR      = "poor"
export const QUALITY_VERY_POOR = "very_poor"

// Bands, exactly as network_diagnostics_controller.js's _quality() originally
// defined them:
//   Good      -- avgMs < 200,  no loss
//   Fair      -- avgMs 200-500, no loss
//   Poor      -- avgMs > 500  OR any loss
//   Very poor -- lossPercent >= 40 OR no response at all
export function classifyQuality(avgMs, lossPercent) {
  if (lossPercent >= 40 || avgMs == null) return QUALITY_VERY_POOR
  if (lossPercent > 0 || avgMs > 500)     return QUALITY_POOR
  if (avgMs > 200)                        return QUALITY_FAIR
  return QUALITY_GOOD
}

export function isPoorOrWorse(band) {
  return band === QUALITY_POOR || band === QUALITY_VERY_POOR
}

export function isGoodOrFair(band) {
  return band === QUALITY_GOOD || band === QUALITY_FAIR
}
